"use client"
import { Modal, Typography, Button, Grid } from "@mui/material"
import { useState, useEffect, useContext } from "react"
import { ErpContext } from "../../context/ErpContext.js"
import PersonIcon from "@mui/icons-material/Person"
import PhoneIcon from "@mui/icons-material/Phone"
import EmailIcon from "@mui/icons-material/Email"
import LocationOnIcon from "@mui/icons-material/LocationOn"
import BadgeIcon from "@mui/icons-material/Badge"
import EditIcon from "@mui/icons-material/Edit"
import AddIcon from "@mui/icons-material/Add"
import CloseIcon from "@mui/icons-material/Close"
import AccountBalanceIcon from "@mui/icons-material/AccountBalance"
import LabelIcon from "@mui/icons-material/Label"
import { Chip } from "@mui/material"
import "./ModalEntidadClienteComponent.css"

const ModalEntidCliente = ({
  open,
  handleClose,
  esClienteExistente,
  entidad,
  abrirCrearCliente,
  crearVentaIgualmente,
  abrirModificarCliente,
  deDondeViene,
  tipoEntidad = "cliente", // "cliente" o "proveedor"
}) => {
  const { getCondicionIvaByEntidad } = useContext(ErpContext)
  const [condicionIvaEntidad, setCondicionIvaEntidad] = useState(null)

  // Etiquetas dinámicas según el tipo de entidad
  const etiquetas = {
    cliente: {
      encontrado: "Cliente Encontrado",
      crear: "Crear Nuevo Cliente",
      modificar: "Modificar Cliente",
      crearBtn: "Crear Cliente",
      noEncontrado: "DNI no encontrado, ¿deseas crear un nuevo cliente?"
    },
    proveedor: {
      encontrado: "Proveedor Encontrado", 
      crear: "Crear Nuevo Proveedor",
      modificar: "Modificar Proveedor",
      crearBtn: "Crear Proveedor",
      noEncontrado: "DNI no encontrado, ¿deseas crear un nuevo proveedor?"
    }
  }

  const labels = etiquetas[tipoEntidad]

  useEffect(() => {
    const obtenerCondicionIva = async () => {
      if (esClienteExistente && entidad && entidad.id) {
        try {
          const condicionIva = await getCondicionIvaByEntidad(entidad.id)
          setCondicionIvaEntidad(condicionIva)
        } catch (error) {
          console.error("Error obteniendo condición IVA:", error)
          setCondicionIvaEntidad(null)
        }
      } else {
        setCondicionIvaEntidad(null)
      }
    }

    obtenerCondicionIva()
  }, [esClienteExistente, entidad, getCondicionIvaByEntidad])
  return (
    <Modal open={open} onClose={handleClose}>
      <div
        className="modalContenido"
        style={{
          backgroundColor: "white",
          borderRadius: "16px",
          padding: "24px",
          width: "80%",
          maxWidth: "700px",
          maxHeight: "90vh",
          overflow: "auto",
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          boxShadow: "0 8px 30px rgba(0, 0, 0, 0.12)",
        }}
      >
        <div
          className="contenedorModal"
          style={{
            position: "relative",
            width: "100%",
          }}
        >
          {/* Botón para cerrar */}
          <div
            style={{
              position: "absolute",
              top: "0",
              right: "0",
            }}
          >
            <Button
              onClick={handleClose}
              style={{
                minWidth: "40px",
                width: "40px",
                height: "40px",
                borderRadius: "50%",
              }}
            >
              <CloseIcon />
            </Button>
          </div>

          {/* Encabezado */}
          <div
            style={{
              textAlign: "center",
              marginBottom: "24px",
              paddingTop: "8px",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginBottom: "8px",
              }}
            >
              {esClienteExistente ? (
                <PersonIcon style={{ color: "#1976d2", fontSize: "32px", marginRight: "8px" }} />
              ) : (
                <AddIcon style={{ color: "#1976d2", fontSize: "32px", marginRight: "8px" }} />
              )}
              <Typography variant="h5" style={{ fontWeight: "600", color: "#1976d2" }}>
                {esClienteExistente ? labels.encontrado : labels.crear}
              </Typography>
            </div>

            {!esClienteExistente && (
              <Typography variant="body1" style={{ color: "#666" }}>
                {labels.noEncontrado}
              </Typography>
            )}
          </div>

          {esClienteExistente ? (
            <>
              <div
                style={{
                  backgroundColor: "#f8f9fa",
                  borderRadius: "12px",
                  padding: "20px",
                  marginBottom: "24px",
                  border: "1px solid #e0e0e0",
                }}
              >
                <Grid container spacing={3}>
                  <Grid item xs={12} md={6}>
                    <Typography
                      variant="subtitle1"
                      style={{
                        fontWeight: "600",
                        color: "#333",
                        marginBottom: "12px",
                        borderBottom: "2px solid #e0e0e0",
                        paddingBottom: "8px",
                      }}
                    >
                      Información Personal
                    </Typography>

                    <div
                      className="contenedorDatoEntidad"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        marginBottom: "12px",
                      }}
                    >
                      <PersonIcon style={{ color: "#1976d2", marginRight: "8px", fontSize: "20px" }} />
                      <Typography
                        className="labelDatoEntidad"
                        style={{
                          fontWeight: "500",
                          color: "#666",
                          marginRight: "8px",
                        }}
                      >
                        Nombre:
                      </Typography>
                      <Typography className="datoEntidad" style={{ fontWeight: "400" }}>
                        {entidad.descripcion}
                      </Typography>
                    </div>

                    <div
                      className="contenedorDatoEntidad"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        marginBottom: "12px",
                      }}
                    >
                      <PersonIcon style={{ color: "#1976d2", marginRight: "8px", fontSize: "20px" }} />
                      <Typography
                        className="labelDatoEntidad"
                        style={{
                          fontWeight: "500",
                          color: "#666",
                          marginRight: "8px",
                        }}
                      >
                        Apellido:
                      </Typography>
                      <Typography className="datoEntidad" style={{ fontWeight: "400" }}>
                        {entidad.apellido}
                      </Typography>
                    </div>

                    <div
                      className="contenedorDatoEntidad"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        marginBottom: "12px",
                      }}
                    >
                      <BadgeIcon style={{ color: "#1976d2", marginRight: "8px", fontSize: "20px" }} />
                      <Typography
                        className="labelDatoEntidad"
                        style={{
                          fontWeight: "500",
                          color: "#666",
                          marginRight: "8px",
                        }}
                      >
                        DNI:
                      </Typography>
                      <Typography className="datoEntidad" style={{ fontWeight: "400" }}>
                        {entidad.dniCuitCuil}
                      </Typography>
                    </div>

                    <div
                      className="contenedorDatoEntidad"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        marginBottom: "12px",
                      }}
                    >
                      <PhoneIcon style={{ color: "#1976d2", marginRight: "8px", fontSize: "20px" }} />
                      <Typography
                        className="labelDatoEntidad"
                        style={{
                          fontWeight: "500",
                          color: "#666",
                          marginRight: "8px",
                        }}
                      >
                        Teléfono:
                      </Typography>
                      <Typography className="datoEntidad" style={{ fontWeight: "400" }}>
                        {entidad.telefono}
                      </Typography>
                    </div>

                    <div
                      className="contenedorDatoEntidad"
                      style={{
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <AccountBalanceIcon style={{ color: "#1976d2", marginRight: "8px", fontSize: "20px" }} />
                      <Typography
                        className="labelDatoEntidad"
                        style={{
                          fontWeight: "500",
                          color: "#666",
                          marginRight: "8px",
                        }}
                      >
                        Condición IVA:
                      </Typography>
                      <Typography className="datoEntidad" style={{ fontWeight: "400" }}>
                        {condicionIvaEntidad?.condicionIva?.descripcion || "No especificada"}
                      </Typography>
                    </div>
                  </Grid>

                  <Grid item xs={12} md={6}>
                    <Typography
                      variant="subtitle1"
                      style={{
                        fontWeight: "600",
                        color: "#333",
                        marginBottom: "12px",
                        borderBottom: "2px solid #e0e0e0",
                        paddingBottom: "8px",
                      }}
                    >
                      Información de Contacto
                    </Typography>

                    <div
                      className="contenedorDatoEntidad"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        marginBottom: "12px",
                      }}
                    >
                      <EmailIcon style={{ color: "#1976d2", marginRight: "8px", fontSize: "20px" }} />
                      <Typography
                        className="labelDatoEntidad"
                        style={{
                          fontWeight: "500",
                          color: "#666",
                          marginRight: "8px",
                        }}
                      >
                        Email:
                      </Typography>
                      <Typography className="datoEntidad" style={{ fontWeight: "400" }}>
                        {entidad.email}
                      </Typography>
                    </div>

                    <div
                      className="contenedorDatoEntidad"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        marginBottom: "12px",
                      }}
                    >
                      <LocationOnIcon style={{ color: "#1976d2", marginRight: "8px", fontSize: "20px" }} />
                      <Typography
                        className="labelDatoEntidad"
                        style={{
                          fontWeight: "500",
                          color: "#666",
                          marginRight: "8px",
                        }}
                      >
                        Dirección:
                      </Typography>
                      <Typography className="datoEntidad" style={{ fontWeight: "400" }}>
                        {entidad.direccion}
                      </Typography>
                    </div>

                    <div
                      className="contenedorDatoEntidad"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        marginBottom: "12px",
                      }}
                    >
                      <LocationOnIcon style={{ color: "#1976d2", marginRight: "8px", fontSize: "20px" }} />
                      <Typography
                        className="labelDatoEntidad"
                        style={{
                          fontWeight: "500",
                          color: "#666",
                          marginRight: "8px",
                        }}
                      >
                        Localidad:
                      </Typography>
                      <Typography className="datoEntidad" style={{ fontWeight: "400" }}>
                        {entidad.localidad}
                      </Typography>
                    </div>

                    <div
                      className="contenedorDatoEntidad"
                      style={{
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <LocationOnIcon style={{ color: "#1976d2", marginRight: "8px", fontSize: "20px" }} />
                      <Typography
                        className="labelDatoEntidad"
                        style={{
                          fontWeight: "500",
                          color: "#666",
                          marginRight: "8px",
                        }}
                      >
                        Provincia:
                      </Typography>
                      <Typography className="datoEntidad" style={{ fontWeight: "400" }}>
                        {entidad.provincia}
                      </Typography>
                    </div>
                  </Grid>
                </Grid>

                {/* Sección de Atributos */}
                {(entidad.opcionAtributo1 || entidad.opcionAtributo2 || entidad.opcionAtributo3 || 
                  entidad.opcionAtributo4 || entidad.opcionAtributo5 || entidad.opcionAtributo6 ||
                  entidad.opcionAtributo7 || entidad.opcionAtributo8 || entidad.opcionAtributo9 || 
                  entidad.opcionAtributo10) && (
                  <div style={{ marginTop: "16px", paddingTop: "16px", borderTop: "1px solid #e0e0e0" }}>
                    <Typography
                      variant="subtitle1"
                      style={{
                        fontWeight: "600",
                        color: "#333",
                        marginBottom: "12px",
                        display: "flex",
                        alignItems: "center",
                        gap: "8px"
                      }}
                    >
                      <LabelIcon style={{ color: "#1976d2" }} />
                      Atributos
                    </Typography>
                    <div style={{ display: "flex", flexWrap: "wrap", gap: "8px" }}>
                      {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((num) => {
                        const opcion = entidad[`opcionAtributo${num}`];
                        if (opcion) {
                          return (
                            <Chip
                              key={num}
                              label={opcion.descripcion}
                              size="medium"
                              color="primary"
                              variant="outlined"
                              style={{
                                fontWeight: "500",
                                borderRadius: "8px"
                              }}
                            />
                          );
                        }
                        return null;
                      })}
                    </div>
                  </div>
                )}
              </div>

              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  gap: "16px",
                  flexWrap: "wrap",
                }}
              >
                {/* Botones de la izquierda */}
                <div
                  style={{
                    display: "flex",
                    gap: "16px",
                    flexWrap: "wrap",
                  }}
                >
                  <Button
                    className="buttonEntidad"
                    onClick={() => abrirModificarCliente(entidad)}
                    variant="contained"
                    startIcon={<EditIcon />}
                    style={{
                      padding: "12px 24px",
                      borderRadius: "8px",
                      fontWeight: "500",
                      boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                      minWidth: "180px",
                    }}
                  >
                    {labels.modificar}
                  </Button>

                  <Button
                    className="buttonEntidad"
                    onClick={abrirCrearCliente}
                    variant="contained"
                    startIcon={<AddIcon />}
                    style={{
                      padding: "12px 24px",
                      borderRadius: "8px",
                      fontWeight: "500",
                      boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                      backgroundColor: "#4caf50",
                      minWidth: "180px",
                    }}
                  >
                    {labels.crearBtn}
                  </Button>
                </div>

                {/* Botón de la derecha */}
                <Button
                  className="buttonEntidad"
                  onClick={handleClose}
                  variant="outlined"
                  style={{
                    padding: "12px 24px",
                    borderRadius: "8px",
                    fontWeight: "500",
                    borderWidth: "2px",
                    minWidth: "120px",
                  }}
                >
                  Cerrar
                </Button>
              </div>
            </>
          ) : (
            <>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  gap: "16px",
                  flexWrap: "wrap",
                  marginTop: "24px",
                }}
              >
                <Button
                  className="buttonEntidad"
                  onClick={abrirCrearCliente}
                  variant="contained"
                  startIcon={<AddIcon />}
                  style={{
                    padding: "12px 24px",
                    borderRadius: "8px",
                    fontWeight: "500",
                    boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                    minWidth: "200px",
                  }}
                >
                  {labels.crearBtn}
                </Button>

                <Button
                  className="buttonEntidad"
                  onClick={handleClose}
                  variant="outlined"
                  style={{
                    padding: "12px 24px",
                    borderRadius: "8px",
                    fontWeight: "500",
                    borderWidth: "2px",
                    minWidth: "120px",
                  }}
                >
                  Cerrar
                </Button>
              </div>
            </>
          )}
        </div>
      </div>
    </Modal>
  )
}

export default ModalEntidCliente

